const zh = {
  meta: {
    base: '《苍翼：混沌效应》官方网站'
  },
  nav: {
    home: "主页",
    role: "角色",
    video: "视频",
    announcement: "重要公告",
  },
  role: {
    playerWarning: "你的浏览器不支持video标签,请换一个浏览器试试。",
    rg: {
      name: "拉格纳",
      intro: "施放技能会消耗生命值，而对敌人造成伤害后又能恢复生命值，生命值越低，伤害越高，恢复效果越强。只要能避开致命的攻击，他的力量将得到完全的释放。"
    },
    a: {
      name: "Λ-No.11-",
      intro: "可以控制背后的剑刃或从虚空中召唤剑刃进行攻击。虽然在前期有攻击能力不足的短板，但激发关键潜能后，可从各处召唤剑刃。不断发射的剑刃会撕碎所有阻挡她的敌人。"
    },
    hk: {
      name: "白面",
      intro: "移动速度较慢，但具有极高的攻击力和防护力，擅长弹反。发动技能格挡敌人的正面攻击后，可以使出毁灭性的招式。不断磨练弹反，甚至能够在零倒地的情况下通关。"
    },
    hb: {
      name: "琥珀响音",
      intro: "会使用各种武器发起攻击，并且能够将影子作为攻击手段。从背后发起攻击时造成的伤害会大幅提升，要想最大程度发挥这一优势，就必须注意调整和敌人的位置关系。"
    },
    nol: {
      name: "诺爱儿",
      intro: "可以使用双枪进行不同方式的射击，同时借助枪的后坐力在空中灵活地位移和攻击。将各种攻击技能运用自如后，可通过在战斗中巧妙组合这些技能，无所顾忌地横冲直撞。"
    },
    kk: {
      name: "九重",
      intro: "可以使用各种武装进行高速移动、展开狂轰滥炸、设置机关。解锁核心潜能后，使用武装还能设置陷阱。基于武装可以扩展出更为丰富的战斗方式。"
    },
    ma: {
      name: "枣麻衣",
      intro: "可使用长枪进行突刺、投掷攻击乃至卷起旋风。激发潜能后，能够进行连续突刺，投掷攻击会更灵活，旋风会有更大的范围。由于附带位移的招式较多，需要注意不要冲到危险中。"
    },
    es: {
      name: "Es",
      intro: "以轻盈的姿态挥舞大剑，释放纹章进行攻击。纹章也具有攻击判定，激发相关核心潜能可使纹章更大更华丽，呈现出花绽全场的战斗效果。"
    },
    tk: {
      name: "桃儿卡卡",
      intro: "拥有很高的机动性和连续性；擅长横冲直撞，同时还能旋转对敌；可以产生分身与本尊一起攻击。"
    },
    rc: {
      name: "雷其儿",
      intro: "能够使唤仆从发动攻击，同时也能够召唤闪电与飓风并在战场上优雅的舞动。"
    },
    jn: {
      name: "如月琴恩",
      intro: "可令敌人减速乃至将其冻结。解锁相关潜能后，拔剑的动作可以格挡攻击，并在格挡成功时对敌人产生额外的攻击，而在收剑瞬间立即出招，可以使出强化招式。只要准确把握出招时机，就能发挥其强大实力。"
    },
    hzm: {
      name: "哈札马",
      intro: "主要使用匕首进行近身作战，能够使用锁链拉近自身与敌人的距离或是快速移动。在获取潜能后能使用各种攻击吸收敌人的MP。"
    },
    // icey: {
    //     name: "艾希",
    //     intro: "来自于异界的少女，能够使用太刀释放各种华丽的斩击，在对敌人造成一定伤害后，还能够进行强力追击；对机械类敌人能够造成额外伤害。"
    // }
    bl: {
      name: "芭烈特",
      intro: "一个擅长打击与投技的角色，可以从多个角度抓取敌人发动攻击，并使用手甲发动炮击。在获取潜能后，不仅能够进入强化状态，还能够从远距离快速突进抓取敌人发动攻击。"
    }
  },
  news: {
    more: "查看更多",
    slider: [
      {
        title: '',
        img: require("@/assets/images/news-slider3-zh.jpg"),
        content: ''
      },
      {
        title: '冲击动作巅峰！超爽动作肉鸽Steam全球发售——《苍翼：混沌效应》',
        img: require("@/assets/images/news-slider1-zh.jpg"),
        content: '<p>《苍翼：混沌效应》已在Steam全球发售，售价68元，首周折扣12%，ACE世界正式连接！</p><p>《苍翼：混沌效应》是由经典格斗IP苍翼默示录官方授权、91Act开发的2D横板动作肉鸽游戏。基于格斗游戏演变而来的全新动作肉鸽，天花板品质的2D动作战斗体验，每个角色完全独立的动作设计，可深度定制组合的、千变万化的角色动作系统！</p><p>点击下方商店链接立即下载，体验极致畅快的2D动作战斗吧！</p><p>Steam商店页：<a href="https://store.steampowered.com/app/2273430">https://store.steampowered.com/app/2273430</a></p><p>官方Q群：928900991</p><p>BiliBili：<a href="https://space.bilibili.com/1663803541">https://space.bilibili.com/1663803541</a></p>'
      },
      {
        title: '《苍翼：混沌效应》首发常见问题解答',
        img: require("@/assets/images/news-slider2-zh.jpg"),
        content: '<p>Q：游戏什么时候发售，售价是多少？</br>A：将于8月16日10:00在Steam全球发售，国区定价68元人民币，首周折扣12%。</p><p>Q：游戏的发售版本有多少内容？</br>A：发售版本游戏的内容量如下：</br>·4组大型主题关卡+1个随机生成的类银河城地图</br>·7位风格迥异的角色和100+角色可选潜能</br>·8种元素体系和200+元素构建策略</br>·10名拥有独特机制的BOSS+50+种不同特色的敌人</br>·所有BOSS形态机制全面进化的进阶挑战模式</br>·成熟独特的剧情表演形式</br>我们希望给出足够丰富的、有诚意的内容，让大家既能体验到这款游戏的魅力，又能值回票价！</p><p>Q：发售后，未来的更新计划是？</br>A：我们计划于9月和11月分别免费更新两次DLC，追加新角色和新剧情。同时在2024年的Q1发布正式版，包括完整的多分支多结局剧情、更多的可操控角色、以及新的游玩模式。</p><p>Q：游戏支持的语言有哪些？</br>A：发售版本在所有地区均完全支持中文语音。同时支持简体中文、英语及日语文本。</p><p>Q：游戏支持的系统以及最低配置？</br>A：同时支持Windows和MacOS系统，为保证游玩流畅度，Windows最低配置建议在Intel Core i3/4 GB RAM/GTX 950及以上，MacOS最低配置建议在MacBook Pro 2018及以上。</p><p>Q：游戏运行推荐的分辨率是？</br>A：推荐在2560*1440（2K）分辨率下运行。</p><p>Q：游戏是否适配手柄和Steam Deck？</br>A：完全适配手柄，在游戏内设置可以自由切换键鼠或手柄，并可以自定义调整键位。游戏也可以在Steam Deck上流畅运行。</p><p>Q：游戏是否支持多人游玩？</br>A：发售版本仅支持单人游玩，暂时没有本地或在线联机内容。</p><p>Q：“迭代测试”获得的兑换码奖励可以在游戏中使用吗？</br>AA：兑换码可以在这次的PC版中使用，但需要在正式版上线后才能兑换，正式版计划于2024年Q1发布。</p><p>Q：如何找到官方资讯和交流平台？</br>你可以关注我们的Steam商店，同时我们也在各大社群建立了官方交流阵地，非常欢迎玩家们加入和我们交流。<br/>官方QQ群：928900991<br/>BiliBili：<a href="https://space.bilibili.com/1663803541">https://space.bilibili.com/1663803541</a> </p><p>Q：如何联系官方人员反馈建议？</br>A：你可以通过上述的社群渠道联络我们，如果你希望更高效实时地和官方人员沟通，强烈推荐加入官方QQ群/Discord。</p>'
      }
    ],
    url: [
      {
        title: "海外独立游戏展会上，这款国产新星让外媒惊艳",
        url: "https://www.tgbus.com/news/208015"
      },
      {
        title: "海外独立游戏展会上的国产新星，游戏出海究竟能有多少种可能",
        url: "https://www.gameweibo.com/article-619892.html",
      },
      {
        title: "《苍翼：混沌效应》抢先评测：更适合动作宝宝体质的肉鸽游戏",
        url: "https://www.3dmgame.com/score/3743068.html",
      },
      {
        title: "国产作品如何在海外独立游戏展上取得好成绩？",
        url: "http://www.chuapp.com/?c=Article&a=index&id=289428",
      }
    ]
  },
  announcement: {
    title: "《苍翼：混沌效应X》实体版首日补丁更新重要公告",
    subTitle: "",
    content: "<p>由于《苍翼：混沌效应X》PS5及NS实体版中部分游戏内容及性能和稳定性优化，需要通过首日补丁网络更新的形式获得，其中也包括了角色【黑铁直人】及游戏模式【极限区域】。因此请购买了《苍翼：混沌效应X》实体版游戏的用户，及时连接网络下载首日补丁更新，以获得完整的游戏体验。</p><br /><p><strong style=\"color: red;\">【特别提醒】</strong></p><br /><p>在未进行首日补丁网络更新前，使用《苍翼：混沌效应X》实体版游戏保存的游戏存档，在更新后的版本中运行，可能会出现剧情模式进程无法推进的问题。如果出现这一情况，您可能需要使用更新后的版本重新建立存档重新开始游戏，方可恢复正常的剧情推进。</p><br /><p>因此，我们强烈推荐各位购买了实体版游戏的用户，请务必先进行首日补丁网络更新再进行游玩，以获得最佳的游戏体验。</p><br /><p>感谢您的配合与理解！</p>"
  }
}
export default zh
